var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "url(#paint0_radial_315_29)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.09659 3V2.71591L2.6392 2.26705C2.67519 2.23722 2.70597 2.20928 2.73153 2.18324C2.75758 2.15672 2.77746 2.1295 2.79119 2.10156C2.8054 2.07363 2.8125 2.04261 2.8125 2.00852C2.8125 1.97112 2.80445 1.93916 2.78835 1.91264C2.77273 1.88613 2.75095 1.86577 2.72301 1.85156C2.69508 1.83688 2.66288 1.82955 2.62642 1.82955C2.58996 1.82955 2.55777 1.83688 2.52983 1.85156C2.50237 1.86624 2.48106 1.88778 2.46591 1.91619C2.45076 1.9446 2.44318 1.97917 2.44318 2.01989H2.06818C2.06818 1.91761 2.09115 1.82955 2.13707 1.75568C2.183 1.68182 2.24787 1.625 2.33168 1.58523C2.41548 1.54545 2.51373 1.52557 2.62642 1.52557C2.7429 1.52557 2.84375 1.54427 2.92898 1.58168C3.01468 1.61861 3.08073 1.67069 3.12713 1.73793C3.17401 1.80516 3.19744 1.884 3.19744 1.97443C3.19744 2.0303 3.18584 2.08594 3.16264 2.14134C3.13944 2.19626 3.09777 2.2571 3.03764 2.32386C2.97751 2.39062 2.89205 2.47017 2.78125 2.5625L2.64489 2.67614V2.68466H3.21307V3H2.09659Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_315_29",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.5 2.5) rotate(90) scale(2.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#66FF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall2);
export default __webpack_public_path__ + "static/media/ball2.13547cbec346c3b93736c5286372d343.svg";
export { ForwardRef as ReactComponent };